<div class="w-72 select-none">
  <div class="flex items-center justify-between mb-3 px-1">
    <span class="text-sm font-semibold text-gray-900">{{ monthLabel() }}</span>
    <div class="flex items-center gap-1">
      <button
        type="button"
        (click)="previousMonth()"
        [disabled]="!canGoBack()"
        class="p-1.5 rounded-full text-[#0A84FF] hover:bg-blue-50 disabled:text-gray-300 disabled:hover:bg-transparent transition-colors"
        aria-label="Previous month"
      >
        <app-icon name="arrow-back" class="w-4 h-4" />
      </button>
      <button
        type="button"
        (click)="nextMonth()"
        [disabled]="!canGoForward()"
        class="p-1.5 rounded-full text-[#0A84FF] hover:bg-blue-50 disabled:text-gray-300 disabled:hover:bg-transparent transition-colors"
        aria-label="Next month"
      >
        <app-icon name="arrow-back" class="w-4 h-4 rotate-180" />
      </button>
    </div>
  </div>

  <div class="grid grid-cols-7 mb-1">
    @for (weekday of weekdays; track $index) {
      <span class="text-center text-xs font-medium text-gray-400 py-1">{{ weekday }}</span>
    }
  </div>

  <div class="grid grid-cols-7 gap-y-0.5" (mouseleave)="hoverDate.set(null)">
    @for (day of days(); track day.date.getTime()) {
      <div class="flex justify-center" [class]="day.cellClass">
        <button
          type="button"
          (click)="select(day)"
          (mouseenter)="hoverDate.set(day.date)"
          [disabled]="day.disabled"
          class="w-9 h-9 rounded-full text-sm transition-colors"
          [class]="day.buttonClass"
        >
          {{ day.label }}
        </button>
      </div>
    }
  </div>
</div>
